/**
 * Schémas de validation des formulaires (Zod + React Hook Form).
 *
 * Ils dupliquent **volontairement** une partie de la politique du serveur : le
 * but est de rendre l'erreur immédiate, pas de la garantir. Le serveur reste
 * seul juge — c'est lui qui connaît la liste des mots de passe courants et le
 * nom de l'utilisateur (docs/06 §6, docs/07 §8).
 */
import { z } from "zod";

/** Aligné sur `PASSWORD_MIN_LENGTH` côté serveur. */
export const PASSWORD_MIN_LENGTH = 12;

const email = z.email();
const password = z.string().min(PASSWORD_MIN_LENGTH);
const requiredName = z.string().trim().min(1).max(100);

export const loginSchema = z.object({
  email,
  // Pas de longueur minimale ici : un mot de passe historique plus court doit
  // pouvoir être saisi pour se connecter, quitte à être refusé par le serveur.
  password: z.string().min(1),
});

export const registerSchema = z.object({
  email,
  password,
  first_name: requiredName,
  last_name: requiredName,
  role: z.enum(["student", "teacher"]),
});

export const emailOnlySchema = z.object({ email });

export const resetPasswordSchema = z.object({ new_password: password });

export type LoginValues = z.infer<typeof loginSchema>;
export type RegisterValues = z.infer<typeof registerSchema>;
export type EmailOnlyValues = z.infer<typeof emailOnlySchema>;
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>;
